import React from 'react';
import { Button, Progress } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScrewdriver, faSquare } from '@fortawesome/free-solid-svg-icons';
import {
    createDataSource, createGridOptions, DataGrid, indexCellRenderer, LinkCellRenderer, TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { ApiRoutes } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';
import { JobTypeForm } from './JobTypeForm';

class JobTypeIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.jobTypeForm = React.createRef();

        this.state = {
            loading: true,
            roles: [],
            showJobTypeForm: false,
        };

        this.onEditJobType = this.onEditJobType.bind(this);
        this.onJobTypeFormClosed = this.onJobTypeFormClosed.bind(this);
    }

    componentDidMount() {
        return this.populateState();
    }

    onEditJobType = (jobType) => {
        this.jobTypeForm.current.open(jobType);
    };

    onJobTypeFormClosed() {
        this.setState({ showJobTypeForm: false });
    }

    onJobTypeSaveCallback = () => {
        this.setState({ showJobTypeForm: false });
        this.context.setFormOpened(false);
        // Refresh grid
        this.state.gridApi.setDatasource(this.state.dataSource);
    };

    populateState() {
        // Get grid defaults and handlers
        const gridOptions = createGridOptions(this);

        // Specify any custom components, filtering
        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        // Provide column definitions
        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 75,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'JobType.Description',
                sortable: true,
                headerName: 'Job Type',
                field: 'description',
                sort: { direction: 'asc', priority: 0 },
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                },
                cellRenderer: 'nameRenderer',
                cellRenderer: (params) => {
                    if (params.data) {
                        return (
                            <Button
                                color="link"
                                className="site-link align-baseline"
                                title="View this Job Type"
                                onClick={() => this.onEditJobType(params.data)}
                            >
                                <FontAwesomeIcon
                                    className="mr-2"
                                    icon={faSquare}
                                    size="xs"
                                    color={params.data.displayColor}
                                />
                                {params.data.description}
                            </Button>
                        );
                    }
                    return null;
                },
            },
            {
                colId: 'InvoiceDescription',
                sortable: false,
                headerName: 'Invoice Description',
                field: 'invoiceDescription',
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                },
            },
        ];

        const dataSource = createDataSource(ApiRoutes.jobType.search(), gridOptions);

        this.setState({
            loading: false,
            gridOptions,
            dataSource,
        });
    }

    render() {
        if (this.state.loading) return (<Progress />);

        const { rowData, gridOptions } = this.state;

        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faScrewdriver}
                        className="mr-2 text-muted"
                    />
                    <span>Job Types</span>
                </PageHeading>
                <DataGridToolbar
                    entity="jobType"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    hideAdd
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
                <JobTypeForm
                    ref={this.jobTypeForm}
                    jobType={this.state.selectedJobType}
                    onClose={this.onJobTypeFormClosed}
                    show={this.state.showJobTypeForm}
                    onSaveCallback={this.onJobTypeSaveCallback}
                />
            </PageWrap>
        );
    }
}
export default JobTypeIndex;
